import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { PlatformType } from '../../constants/common';
import ivclass from '../../Modules/IVClass';
import FooterLink from './FooterLink';
import GlobalConfig from '../../lib/GlobalConfig';
import { sendRudderStackAnalyticsEvent } from '../../lib/BaseAnalyticsEvent';
const getPlatformURL = (appPromoLink, appOS, platform) => {
    if (PlatformType.Desktop === platform) {
        return appPromoLink.desktop[appOS].url;
    }
    return appPromoLink.mobile.iOS.url;
};
const getURL = (key, link, appOS, platform) => {
    let url = '#';
    if (key && key === '{{footer_app_promo}}') {
        url = getPlatformURL(GlobalConfig.APP_PROMO_LINKS, appOS, platform);
    }
    else if (link) {
        url = link;
    }
    return url;
};
const initLiveChat = () => {
    sendRudderStackAnalyticsEvent({
        eventName: 'click_cta',
        eventProperties: {
            type: 'click_support',
            ux_source: 'click_footer',
            feature_utm: 'na',
        },
    });
    const liveChatElement = document.getElementById('fresh-chat-custom');
    liveChatElement?.click();
};
const FooterItems = (props) => {
    const { footerItems, os, platform, options } = props;
    const { title, list, color } = footerItems;
    return (_jsxs(_Fragment, { children: [_jsx("h2", { className: ivclass('xl:iv-text-body-l iv-text-body-m', 'iv-m-body-xl', color || 'iv-text-grey-70 dark:iv-text-grey-0', 'iv-font-semibold'), children: title }), _jsx("div", { className: ivclass('iv-flex', 'iv-flex-col', 'iv-items-baseline', 'iv-mt-15 xl:iv-mb-35 iv-mb-30', 'xl:iv-pb-2 lg:iv-py-1 md:iv-pt-2'), children: list.map(item => {
                    if (item.key === '{{footer_app_promo}}' &&
                        platform === PlatformType.Mobile &&
                        item.appOS !== os) {
                        return _jsx(React.Fragment, {}, item.name);
                    }
                    const url = getURL(item.key, item.link, item.appOS, platform);
                    if (item?.key === '{{footer_live_chat}}' && options?.hideSupport) {
                        return null;
                    }
                    if (item?.key === '{{footer_live_chat}}') {
                        return (_jsx(FooterLink, { url: url, onClick: initLiveChat, children: _jsx("span", { children: item.name }) }, item.name));
                    }
                    else if (item?.key === '{{footer_jobs}}') {
                        return (_jsxs(FooterLink, { url: url, external: item.external, children: [_jsx("span", { children: "Jobs \u00B7" }), _jsx("span", { className: ivclass('iv-text-raspberry'), children: "\u00A0We are hiring!" })] }, item.name));
                    }
                    else {
                        return (_jsx(FooterLink, { url: url, external: item.external, children: _jsxs("div", { className: ivclass('iv-flex iv-gap-[3px]'), children: [_jsx("span", { children: item.name }), item.icon && (_jsx("img", { src: item.icon.url, alt: item.icon.alt, width: item.icon.width, height: item.icon.height }))] }) }, item.name));
                    }
                }) })] }));
};
export default FooterItems;
